// every input/select with data-element="input"  will be iterated through to add to the endpointurl using the name="sort" value="name" for values in makeEndpointUrl()
// as such `apiurl/?name=value&name2=value2`

// data-behaviour="endpoint-input" on change will take the value and do an api call regardless of other select/inputs values

// data-behaviour="trigger-call" on any select/input will trigger on input to getResults()
import { _, debug, debounce } from '../utils.js'
import axios from 'axios'
import Loading from '../modules/loading.js'
import errorMessageContainer from '../templates/error.js'
import tableRowUsers from '../templates/table-row-user.js'
import tableRowInvoices from '../templates/table-row-invoices.js'
import tableRowBranches from '../templates/table-row-branch.js'
import FormPost from '../modules/form-post.js'
import CheckboxToggle from '../modules/checkbox-toggle.js'
import PcaLookup from '../modules/pca-lookup.js'
import Tooltip from '../modules/tooltip.js'

export default class TableListing {
    constructor(el) {
        this.el = el
        this.searchInput = _('input-search').nodeFrom(this.el)
        this.table = _('table-select', 'element').nodeFrom(this.el)
        this.tableType = this.table.dataset.tableType
        this.totalItems = _('total-items', 'element').nodeFrom(this.el)
        this.defaultErrorMessage =
            'Something has gone quite wrong, please try to refresh your browser or contact us.'
        this.pagination = _('pagination', 'element').nodeFrom(this.el)
        this.paginator = _('pagination-input').nodeFrom(this.el)
        this.previousPageTrigger = _('previous-page').nodeFrom(this.el)
        this.nextPageTrigger = _('next-page').nodeFrom(this.el)
        this.paginatorList = _('pagination-list', 'element').nodeFrom(this.el)

        // If pagination is using the included element (ie. Corporate member list within My Account, for Primary Contacts),
        // then the paginator selector never matches.  As this script file (table-listing.js) can be used by multiple pages,
        // we need to ensure we don't make changes here that are incompatible with those other pages.
        if (this.paginator === null) {
            this.paginator = _('pagination', 'element').nodeFrom(this.el)
        }

        this.inputs = _('input', 'element').nodesFrom(this.el)
        this.sorts = _('sort').nodesFrom(this.el)
        this.action = this.el.dataset.action || 'get'
        this.errorContainer = _('error-container', 'element').nodesFrom(this.el)
        this.resultsContainer = _('results-container', 'element').nodeFrom(
            this.el,
        )
        this.endpointInput = _('endpoint-input').nodeFrom(this.el)
        this.totalPages = _('total-pages', 'element').nodeFrom(this.el)
        this.modalMessageContainer = _(
            'modal-message-container',
            'element',
        ).nodeFrom(this.el)
        this.endpointInput.addEventListener('change', this.getResults)
        this.pagination?.addEventListener('change', this.makeEndpointUrl)
        this.searchInput?.addEventListener('input', debounce(this.search, 500))
        this.triggerCall = _('trigger-call').nodeFrom(this.el)
        this.makeEndpointUrl()

        this.sorts.map((sortEl) => {
            sortEl.addEventListener('click', this.sort)
        })
        this.triggerCall.addEventListener('input', this.getResults)
        if (this.inputs) {
            this.inputs.map((input) => {
                input.addEventListener('change', this.makeEndpointUrl)
            })
        }
        if (this.previousPageTrigger) {
            this.previousPageTrigger.addEventListener(
                'click',
                this.goPreviousPage,
            )
        }
        if (this.nextPageTrigger) {
            this.nextPageTrigger.addEventListener('click', this.goNextPage)
        }
    }

    /**
     * @param  {object} checkboxEls - array of checkbox nodes
     */

    goNextPage = () => {
        this.paginator.value++
        this.makeEndpointUrl()
    }

    goPreviousPage = () => {
        this.paginator.value--
        this.makeEndpointUrl()
    }

    changePaginationInput = (event) => {
        this.paginator.value = event.target.value
        this.makeEndpointUrl()
    }

    getDeleteValues = (checkboxEls) => {
        return () => {
            let checkboxList = ''
            const errorMessage = _('delete', 'response').nodeFrom(this.el)
            checkboxEls.map((el) => {
                if (el.checked) {
                    checkboxList += `${el.value},`
                }
            })

            _('delete-values', 'element').nodeFrom(this.el).value = checkboxList
            if (checkboxList) {
                errorMessage.dataset.customError = this.defaultErrorMessage
            } else {
                errorMessage.dataset.customError = `You have not selected any ${this.tableType}`
            }
        }
    }

    showLoading = () => {
        this.resultsContainer.innerHTML = `<tr class="table__loading loading" ><td data-behaviour="loading" colspan="${this.table.dataset.columns}"></td></tr>`
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    hideLoading = () => {
        this.resultsContainer.innerHTML = ''
    }

    search = (e) => {
        if (e.target.value.length > 2 || e.target.value.length === 0) {
            this.pagination.value = 1
            this.makeEndpointUrl()
        }
    }

    sort = (e) => {
        this.sorts.map((sortEl) => {
            if (sortEl !== e.currentTarget) {
                sortEl.dataset.direction = 'none'
            }
        })
        if (e.currentTarget.dataset.direction === 'none') {
            e.currentTarget.dataset.direction = 'asc'
        } else if (e.currentTarget.dataset.direction === 'asc') {
            e.currentTarget.dataset.direction = 'desc'
        } else {
            e.currentTarget.dataset.direction = 'none'
        }

        this.el.querySelector('[name="sortBy"]').value =
            e.currentTarget.dataset.sort
        this.el.querySelector('[name="sortDirection"]').value =
            e.currentTarget.dataset.direction
        this.makeEndpointUrl()
    }

    makeEndpointUrl = (e) => {
        this.startEndpoint = this.endpointInput.value.split('?')
        this.endpoint = this.startEndpoint[0]
        let operator = '?'
        if (this.inputs.length) {
            this.inputs.map((el, i) => {
                if (i) {
                    operator = '&'
                }
                this.endpoint += `${operator}${el.getAttribute('name')}=${
                    el.value
                }`
            })
        }
        this.endpointInput.value = this.endpoint

        if (
            !!e &&
            !!e.currentTarget &&
            e.currentTarget.dataset.element === 'pagination'
        ) {
            this.getResults(true)
        } else {
            this.getResults(false)
            this.resetPaginator()
        }
    }

    resetPaginator = () => {
        if (this.paginator) {
            this.paginator.value = 1
        }
    }

    getResults = (scrollTop = false) => {
        if (this.modalMessageContainer) {
            this.modalMessageContainer.innerHTML = ''
        }
        this.showLoading()
        axios({
            method: this.action,
            url: this.endpointInput.value,
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }
                this.handleSuccess(response.data)
                this.reEnableModules()
                if (this.pagination) {
                    this.buildPagination(response.data.result.pagination)
                }
                if (scrollTop) {
                    this.scrollToResultsTop()
                }
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    scrollToResultsTop = () => {
        window.scrollTo({
            top:
                this.resultsContainer.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                100,
            behavior: 'smooth',
        })
    }

    reEnableModules = () => {
        const checkboxEls = _('delete-checkbox').nodesFrom(
            this.resultsContainer,
        )

        checkboxEls.map((el) => {
            el.addEventListener('change', this.getDeleteValues(checkboxEls))
        })
        _('form-post')
            .nodesFrom(this.resultsContainer)
            .map((el) => new FormPost(el))

        _('fieldset', 'element')
            .nodesFrom(this.resultsContainer)
            .map((el) => new CheckboxToggle(el))

        _('table-select', 'element')
            .nodesFrom(this.resultsContainer)
            .map((el) => new CheckboxToggle(el))

        _('postcode-lookup', 'element')
            .nodesFrom(this.resultsContainer)
            .map((el) => new PcaLookup(el))

        _('tooltip')
            .nodesFrom(this.resultsContainer)
            .map((el) => new Tooltip(el))
    }

    buildPagination = (paginationResponse) => {
        if (!paginationResponse) {
            return false
        }
        if (
            paginationResponse.totalPages !== null &&
            paginationResponse.totalPages < 2
        ) {
            this.pagination.classList.add('u-hidden')
            return false
        } else {
            this.pagination.classList.remove('u-hidden')
        }
        const totalPages = paginationResponse.totalPages
        const currentPage = paginationResponse.currentPage
        let paginationHTML = ''

        const isInRange = (i) => Math.abs(currentPage - i) <= 2

        // Display one empty button before the range if page 1 is not in range
        if (currentPage > 3) {
            paginationHTML += `<li class="pagination__item">
            <button class="pagination__link" value="1" data-behaviour="pagination-button">
            1
            </button>
            </li>`
        }

        // Display one empty button before the range
        if (currentPage > 3) {
            paginationHTML += `<li class="pagination__item">
            <button class="pagination__link pagination__link--no-border" disabled>
            ...
            </button>
            </li>`
        }

        // Display buttons within the range
        for (let i = 1; i <= totalPages; i++) {
            const isCurrentPage = i === currentPage

            if (isCurrentPage || isInRange(i)) {
                paginationHTML += `<li class="pagination__item ${
                    isCurrentPage ? 'pagination__item--active' : ''
                }">
                <button class="pagination__link" value="${i}" data-behaviour="pagination-button">
                ${i}
                ${isCurrentPage ? '<span class="sr-only">current</span>' : ''}
                </button>
                </li>`
            }
        }

        // Display one empty button after the range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<li class="pagination__item">
            <button class="pagination__link pagination__link--no-border" disabled>
            ...
            </button>
            </li>`
        }

        // Display one empty button after the range if the last page is not in range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<li class="pagination__item">
            <button class="pagination__link" value="${totalPages}" data-behaviour="pagination-button">
            ${totalPages}
            </button>
            </li>`
        }

        this.paginatorList.innerHTML = paginationHTML
        this.totalPages.value = paginationResponse.totalPages
        this.paginator.value = paginationResponse.currentPage
        if (this.previousPageTrigger) {
            this.previousPageTrigger.disabled = currentPage === 1
        }

        if (this.nextPageTrigger) {
            this.nextPageTrigger.disabled = currentPage === totalPages
        }
        _('pagination-button')
            .nodesFrom(this.el)
            .forEach((buttonElement) => {
                buttonElement.addEventListener('click', (event) => {
                    this.changePaginationInput(event)
                })
            })
        return false
    }

    handleSuccess = (response) => {
        this.hideLoading()
        if (this.tableType === 'users') {
            this.buildUserRows(response)
        }
        if (this.tableType === 'branches') {
            this.buildBranchRows(response)
        }
        if (this.tableType === 'invoices') {
            this.buildInvoiceRows(response)
        }
    }

    buildUserRows = (response) => {
        let resultsHTML = ''
        for (let i = 0; i < response.result.items.length; i++) {
            const item = tableRowUsers(response.result.items[i])
            resultsHTML += item
        }
        this.resultsContainer.innerHTML = resultsHTML
        this.totalItems.innerHTML = `${response.result.total} user${
            response.result.total > 1 ? 's' : ''
        }`
    }

    buildInvoiceRows = (response) => {
        let resultsHTML = ''
        for (let i = 0; i < response.result.items.length; i++) {
            const item = tableRowInvoices(response.result.items[i])
            resultsHTML += item
        }
        this.resultsContainer.innerHTML = resultsHTML
        this.totalItems.innerHTML = `${response.result.total} invoice${
            response.result.total > 1 ? 's' : ''
        }`
    }

    buildBranchRows = (response) => {
        let resultsHTML = ''
        for (let i = 0; i < response.result.items.length; i++) {
            const item = tableRowBranches(response.result.items[i])
            resultsHTML += item
        }
        this.resultsContainer.innerHTML = resultsHTML
        this.totalItems.innerHTML = `${response.result.total} branch${
            response.result.total > 1 ? 'es' : ''
        }`
    }

    handleError = (err, defaultMessage = this.defaultErrorMessage) => {
        if (debug) {
            console.warn({ err })
        }
        this.hideLoading()
        let errorHTML = `<p>${defaultMessage}</p>`
        if (err && err.errors) {
            err.errors.map((el) => {
                errorHTML += `<p>${el}</p>`
            })
        }
        this.errorContainer.innerHTML = errorMessageContainer(errorHTML)
    }
}
